module.exports = __webpack_public_path__ + "fonts/tianhong.b9fff864.ttf";